import React, { useContext } from 'react';
import { Button, Dropdown, Icon } from '@/components/shared';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { SegmentationResponse } from '@/generated/data.schemas';
import { useGetSettings } from '@/generated/settings';
import styles from './LanguageDropdown.module.scss';

export const LanguageDropdown: React.FunctionComponent = () => {
	const { segmentationId } = useContext(SegmentationContext);
	const { data: settings, isLoading } = useGetSettings(segmentationId);

	if (isLoading) return null;

	const currentSegmentation = settings?.data.segmentations.find((item) => item.isCurrentSegmentation);

	return (
		<Dropdown
			className={styles.placement}
			buttonVariant={'ghost'}
			buttonSize={'sm'}
			buttonLabel={
				<span className={styles.triggerButtonLabel}>
					<Icon name={'globe'} size={'md'} />
					{currentSegmentation?.name}
				</span>
			}
			noRadius
			alignContentRight
			ariaControls="languageDropdown"
		>
			<ul className={styles.menuList}>
				{(settings?.data.segmentations as SegmentationResponse[]).map((item) => (
					<li key={item.name}>
						<Button
							className={styles.menuLink}
							variant={'ghost'}
							size={'sm'}
							isFullWidth
							noRadius
							href={item.url}
							aria-current={item.isCurrentSegmentation ? 'page' : undefined}
						>
							{item.name}
						</Button>
					</li>
				))}
			</ul>
		</Dropdown>
	);
};
